<div class="header">
  <div class="title">Ссылки</div>
  <div class="buttons">
    <button mat-icon-button
            matTooltip="Добавить ссылку"
            (click)="openTestLinkCreateDialog()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
<div class="body">
  <app-test-links-table [testId]="testId"
                        [testLinks]="testLinks"
                        (delete)="openTestLinkDeleteDialog($event)"></app-test-links-table>
</div>
